import { NativeModule } from "./RemoteCommandsModule.web.ts";
import type { RemoteCommandEvent } from "./RemoteCommands.types.ts";

type ListenerSubscription = { remove(): void };

export function setRemoteCommandsEnabled(enabled: boolean): void {
  NativeModule.setEnabled(enabled);
}

export function onRemoteCommand(
  listener: (event: RemoteCommandEvent) => void,
): ListenerSubscription {
  return NativeModule.addListener("onRemoteCommand", listener);
}

export type { RemoteCommand, RemoteCommandEvent } from "./RemoteCommands.types.ts";
